// api/AdminService.ts
import { $Service } from "./Service";
import axios from "axios";
import {
  Company,
  CreateUserCompanyReq,
  UserCompany,
} from "../types/companyTypes";
import { User } from "../types/commonTypes";

export default class AdminService extends $Service {
  private readonly API_PREFIX = "/_admin";

  public getAllCompanies(): Promise<Company[]> {
    return this.client.get("_admin/companies");
  }
  async getAllUsers(): Promise<User[]> {
    return this.client.get(`${this.API_PREFIX}/users`);
  }

  async createUserCompany(
    createUserCompanyReq: CreateUserCompanyReq
  ): Promise<UserCompany> {
    return this.client.post(
      `${this.API_PREFIX}/companies/user-companies`,
      createUserCompanyReq
    );
  }

  async syncCognitoUsersToDb(): Promise<{ number: number }> {
    return this.client.post(`${this.API_PREFIX}/cognito/sync`);
  }
}
